// extracted by mini-css-extract-plugin
module.exports = {"bg":"App_bg__Udd20","body":"App_body__MlnZO"};